export default {
  greeting: 'হ্যালো এই হোম পেজ',
  intro: 'সরলওয়েবে স্বাগতম, আমরা একটি অত্যাধুনিক প্রযুক্তি কোম্পানী যা সহজবোধ্য প্রদানের জন্য নিবেদিত'
}
